import GrowthAcquisitionEpicClient from 'bundles/epic/clients/GrowthAcquisition';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const showSkillsAdvancersQuestionInOnboarding = () =>
  GrowthDiscoveryEpicClient.preview('enableOnboardingAdvancersHomeComplexCollection');

export const shouldUseNewOnboardingRoute = () => GrowthAcquisitionEpicClient.preview('shouldUseNewOnboardingRoute');
